export type LinkData = { href: string; value: string };

const EMAIL_REGEX =
  /^(?=.{1,254}$)(?=.{1,64}@)[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?\.)+[A-Za-z]{2,}$/;
const URL_REGEX =
  /^(?:(?:https?):\/\/)?(?:localhost|(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)\.)+[a-zA-Z]{2,})(?::\d{2,5})?(?:[/?#][^\s]*)?$/i;

export const isValidEmailFormat = (value: string): boolean => EMAIL_REGEX.test(value);

export const isValidWebsiteUrl = (value: string): boolean => {
  const hasProtocol = /^https?:\/\//i.test(value);
  if (!URL_REGEX.test(value)) {
    return false;
  }

  if (hasProtocol || value.toLowerCase().startsWith('localhost')) {
    return true;
  }

  const host = value.split(/[/?#:]/, 1)[0];
  return host.split('.').length === 2;
};

export const getLinkData = (value: unknown): LinkData | null => {
  if (typeof value !== 'string') {
    return null;
  }

  const normalizedValue = value.trim();
  if (!normalizedValue || normalizedValue === '-') {
    return null;
  }

  if (isValidEmailFormat(normalizedValue)) {
    return { href: `mailto:${normalizedValue}`, value: normalizedValue };
  }

  if (isValidWebsiteUrl(normalizedValue)) {
    const hasProtocol = /^https?:\/\//i.test(normalizedValue);
    return {
      href: hasProtocol ? normalizedValue : `https://${normalizedValue}`,
      value: normalizedValue,
    };
  }

  return null;
};
